import React from 'react';
import PackingListView from './PackinListView';
import PackingListEdit from './PackingListEdit';

interface PackingListProps {
  export_id: string | null;
  editable: boolean;
  status: string | null;
  onPackingListChange?: (lines: any[]) => void;
}

const PackingList: React.FC<PackingListProps> = ({ export_id, editable, onPackingListChange }) => {
  return editable ? (
    <PackingListEdit export_id={export_id} editable={true} onPackingListChange={onPackingListChange} />
  ) : (
    <PackingListView export_id={export_id} />
  );
};

export default PackingList;
